module.exports = __webpack_public_path__ + "img/Lentera Dana Nusantara.d007d009.png";